import Formatter from "../formatter"
import BaseLogic from "../base_logic"
import moment from "moment"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import vuexStore from "@/store"
import router from "@/router"
import RouteNames from "@/util/route_names"
import {
  Oeffnungszeiten,
  Oeffnungszeiten_Oeffnung as Oeffnung,
  Verfuegbarkeit,
  Verfuegbarkeit_Tag as VerfuegbarkeitTag,
  Verfuegbarkeit_Uhrzeit as VerfuegbarkeitUhrzeit,
  VerfuegbarkeitRequest,
  RemoteResult,
  OeffnungRequest,
  Terminart,
  RPTerminWaehlenRequest,
  ReservierungPending,
  LoadState,
} from "mangdto"

export default class TerminReservierungNeuLogic extends BaseLogic {
  minDate: string = null
  maxDate: string = null
  geoeffneteTage: Oeffnung[] = []
  allowedDates: VerfuegbarkeitTag[] = []
  private _selectedDate: string = null
  derTag: VerfuegbarkeitTag = null
  derSlot: VerfuegbarkeitUhrzeit = null
  selectedOeffnung: Oeffnung = null
  _selectedPersonen: number = 2
  private _pickerDate: string = null
  availableDates: VerfuegbarkeitTag[] = []
  pickerDisabled = false
  private _raucher: number = 2
  private _aussenbereich: number = 2
  personenDialogVisible: boolean = false
  bestaetigenLoadState: LoadState = LoadState.Idle

  _pickerMonth: any

  checkStates = [
    { value: 0, display: "ja" },
    { value: 1, display: "nein" },
    { value: 2, display: "egal" },
  ]

  get pickerMonth(): any {
    return this._pickerMonth
  }

  set pickerMonth(newValue) {
    this._pickerMonth = newValue
    this.reloadDates()
  }

  get aussenbereich(): number {
    return this._aussenbereich
  }

  set aussenbereich(newValue: number) {
    this._aussenbereich = newValue
    this.selectedPersonen = 2
    this.reloadDates()
  }

  get raucher(): number {
    return this._raucher
  }

  set raucher(newValue: number) {
    this._raucher = newValue
    this.selectedPersonen = 2
    this.reloadDates()
  }

  get slotFormatiert(): string {
    if (this.derSlot == null) {
      return null
    }

    return (
      Formatter.formatiereUhrzeit(this.derSlot.uhrzeitVon) +
      " - " +
      Formatter.formatiereUhrzeit(this.derSlot.uhrzeitBis)
    )
  }

  get selectedPersonen() {
    return this._selectedPersonen
  }

  set selectedPersonen(value: number) {
    this._selectedPersonen = value
    this.derSlot = null
    this._selectedDate = null
  }

  get selectedDate(): string {
    return this._selectedDate
  }

  set selectedDate(value: string) {
    this._selectedDate = value

    var oeffnung = null

    this.availableDates.forEach((element) => {
      if (element.datum === value) {
        this.derTag = element
      }
    })

    this.geoeffneteTage.forEach((toCompare) => {
      if (toCompare.datum === value) {
        oeffnung = toCompare
      }
    })
    this.selectedOeffnung = oeffnung
  }

  get pickerDate(): string {
    return this._pickerDate
  }

  set pickerDate(value: string) {
    this._pickerDate = value
    this.reloadDates()
  }

  init() {
    var filialeId = this.filiale.filialeId
    var request = new OeffnungRequest()
    request.filialeId = filialeId
    request.terminart = Terminart.Reservierung

    Poster.postUser<RemoteResult<Oeffnungszeiten>>(
      RestPaths.oeffnungszeitOeffnungszeiten,
      request,
    ).then((response) => {
      this.minDate = response.data.payload.minDate
      this.maxDate = response.data.payload.maxDate
      this.geoeffneteTage = response.data.payload.daten
    })
  }

  reloadDates() {
    if (this._pickerMonth == null) return
    var request = new VerfuegbarkeitRequest()
    request.filialeId = this.filiale.filialeId
    // request.monat = 7
    // request.jahr = 2025
    request.monat = moment(this._pickerMonth, "yyyy-MM").format(
      "M",
    ) as unknown as number
    request.jahr = moment(this._pickerMonth, "yyyy-MM").format(
      "yyyy",
    ) as unknown as number
    request.personen = this.selectedPersonen
    request.aussenbereich = this._aussenbereich
    request.raucher = this._raucher

    this.pickerDisabled = true

    Poster.postUser<RemoteResult<Verfuegbarkeit>>(
      RestPaths.reservierungenErmittleTimeSlots,
      request,
    ).then((response) => {
      this.availableDates = response.data.payload.tage
      var verfuegbareTage = []

      this.availableDates.forEach((element) => {
        if (element.slots.length > 0) {
          verfuegbareTage.push(element)
        }
      })

      this.allowedDates = verfuegbareTage
      this.pickerDisabled = false
    })
  }

  terminBestaetigen() {
    this.bestaetigenLoadState = LoadState.Loading

    var request = new RPTerminWaehlenRequest()
    request.identifier = vuexStore.state.user.identifier
    request.personen = this.selectedPersonen
    request.zeitVon = this.derSlot.uhrzeitVon
    request.zeitBis = this.derSlot.uhrzeitBis
    request.tischId = this.derSlot.tischId
    request.aussenbereich = this.aussenbereich
    request.raucher = this.raucher
    request.identifier = vuexStore.state.user.identifier

    Poster.postMember<RemoteResult<string>>(
      RestPaths.reservierungenPendingTerminWaehlen,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.bestaetigenLoadState = LoadState.Completed

          this.mainLogic.reservierungPending = new ReservierungPending()
          this.mainLogic.reservierungPending.personen = this.selectedPersonen
          this.mainLogic.reservierungPending.zeitVon = this.derSlot.uhrzeitVon
          this.mainLogic.reservierungPending.zeitBis = this.derSlot.uhrzeitBis
          this.mainLogic.reservierungPending.tischId = this.derSlot.tischId

          this.mainLogic.neueReservierung = true
          router.push({ name: RouteNames.NEU.KUNDENDATEN_RESERVIERUNG })
        } else {
          this.bestaetigenLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.bestaetigenLoadState = LoadState.Error
      })
  }

  slotWaehlen(slot) {
    this.derSlot = slot
  }
}
